import script from "./myListDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./myListDetailPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__